function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { getUiOptions } from './';
export const getUploadButton = ({
  schema,
  button,
  onUpload
}) => {
  let itemSchema, multiple;

  if (schema.type === "array") {
    multiple = true;
    itemSchema = schema.items;
  } else {
    multiple = false;
    itemSchema = schema;
  }

  if (!itemSchema || !itemSchema.properties) {
    return {
      label: "failed"
    };
  }

  let mediaType;

  if (itemSchema.properties.media && itemSchema.properties.media.properties && itemSchema.properties.media.properties.mediaType && itemSchema.properties.media.properties.mediaType.default) {
    mediaType = itemSchema.properties.media.properties.mediaType.default;
  }

  let accept = button.accept || undefined;

  if (!accept && mediaType) {
    if (mediaType === "image") {
      accept = "image/*";
    }

    if (mediaType === "video") {
      accept = "video/*";
    }

    if (mediaType === "audio") {
      accept = "audio/*";
    }
  }

  if (!onUpload) {
    return _extends({}, button, {
      disabled: true
    });
  }

  return _extends({}, button, {
    type: "upload",
    accept: accept,
    multiple: multiple,
    onUpload: onUpload
  });
};
export const getDialogButton = (_ref) => {
  let schema = _ref.schema,
      button = _ref.button,
      onDialog = _ref.onDialog,
      type = _ref.type,
      registry = _ref.registry,
      props = _objectWithoutPropertiesLoose(_ref, ["schema", "button", "onDialog", "type", "registry"]);

  let itemSchema;

  if (schema.type === "array") {
    itemSchema = schema.items;
  } else {
    itemSchema = schema;
  }

  if (!onDialog) {
    return _extends({}, button, {
      disabled: true
    });
  }

  return _extends({}, button, {
    onClick: event => onDialog(event, button)
  });
};
export const getButton = (_ref2) => {
  let schema = _ref2.schema,
      button = _ref2.button,
      onAdd = _ref2.onAdd,
      onUpload = _ref2.onUpload,
      onDialog = _ref2.onDialog,
      onSave = _ref2.onSave,
      onRemove = _ref2.onRemove,
      onDelete = _ref2.onDelete,
      onRestore = _ref2.onRestore,
      props = _objectWithoutPropertiesLoose(_ref2, ["schema", "button", "onAdd", "onUpload", "onDialog", "onSave", "onRemove", "onDelete", "onRestore"]);

  if (typeof button === "string") {
    button = {
      type: button,
      label: button.charAt(0).toUpperCase() + button.slice(1)
    };
  }

  const _button = button,
        type = _button.type,
        item = _button.item,
        onClick = _button.onClick;

  if (onClick) {
    return button;
  }

  if (type === "upload") {
    button = getUploadButton(_extends({
      schema,
      button,
      onUpload
    }, props));
  } else if (type === "save") {
    button = _extends({}, button, {
      onClick: () => onSave()
    });
    /*
     } else if (type === "remove") {
        button = {
            ...button,
            onClick: () => onRemove()
        }
     */
  } else if (type === "delete") {
    button = _extends({}, button, {
      onClick: () => onDelete()
    });
  } else if (type === "restore") {
    button = _extends({}, button, {
      onClick: () => onRestore()
    });
  } else if (type && type.startsWith("dialog") || type && type.startsWith("sidebar")) {
    button = getDialogButton(_extends({
      schema,
      button,
      onDialog,
      type
    }, props));
  } else if (onAdd && item) {
    button = _extends({}, button, {
      onClick: () => onAdd(item)
    });
  } else if (onAdd) {
    button = _extends({}, button, {
      onClick: () => onAdd()
    });
  }

  return button;
};
export const getArrayButtons = (_ref3) => {
  let _ref3$buttons = _ref3.buttons,
      buttons = _ref3$buttons === void 0 ? [] : _ref3$buttons,
      canAdd = _ref3.canAdd,
      onAddItem = _ref3.onAddItem,
      props = _objectWithoutPropertiesLoose(_ref3, ["buttons", "canAdd", "onAddItem"]);

  if (!canAdd) {
    return false;
  }

  let uiButtons = [];
  const onAdd = canAdd && onAddItem;

  if (buttons && buttons.length) {
    uiButtons = buttons.map(button => {
      return getButton(_extends({
        button,
        onAdd
      }, props));
    });
  } else if (onAdd) {
    buttons = ["add"];
    uiButtons = buttons.map(button => {
      return getButton(_extends({
        button,
        onAdd
      }, props));
    });
  }

  return uiButtons;
};
export const getObjectButtons = (_ref4) => {
  let _ref4$buttons = _ref4.buttons,
      buttons = _ref4$buttons === void 0 ? [] : _ref4$buttons,
      onChange = _ref4.onChange,
      props = _objectWithoutPropertiesLoose(_ref4, ["buttons", "onChange"]);

  let uiButtons = [];
  const onAdd = onChange;

  if (buttons && buttons.length) {
    uiButtons = buttons.map(button => {
      return getButton(_extends({
        button,
        onAdd
      }, props));
    });
  } else if (props.editable) {
    buttons = ["save"];
    uiButtons = buttons.map(button => {
      return getButton(_extends({
        button,
        onAdd
      }, props));
    });
  }

  return uiButtons;
};
export const getUiButtons = (_ref5) => {
  let _ref5$schema = _ref5.schema,
      schema = _ref5$schema === void 0 ? {} : _ref5$schema,
      props = _objectWithoutPropertiesLoose(_ref5, ["schema"]);

  const id = props.id,
        uiSchema = props.uiSchema,
        formContext = props.formContext;
  const currentId = formContext && formContext.currentId;

  const _getUiOptions = getUiOptions(uiSchema),
        buttons = _getUiOptions.buttons,
        editable = _getUiOptions.editable,
        nav = _getUiOptions.nav; // dont show button if we're editing a child, unless there is navigation involved


  if (!nav && currentId && id && currentId !== id && currentId.includes(id)) {
    return false;
  }

  if (schema.type === "array") {
    return getArrayButtons(_extends({
      schema,
      buttons
    }, props));
  }

  if (schema.type === "object") {
    return getObjectButtons(_extends({
      schema,
      buttons,
      editable
    }, props));
  }
};